"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownField = _ref => {
  let {
    options,
    selected,
    onChange,
    caption,
    disabled
  } = _ref;
  const defaultValue = getDefaultValue(selected, options);
  (0, _react.useEffect)(() => {
    if (defaultValue) {
      const {
        value
      } = defaultValue;
      onChange({
        enabled: true,
        value
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_shared.Caption, {
    captionValues: caption
  }, /*#__PURE__*/_react.default.createElement(_shared.StyledDropdown, {
    defaultValue: defaultValue,
    items: options,
    onChange: _ref2 => {
      let {
        selectedItem: {
          value
        }
      } = _ref2;
      return onChange({
        enabled: true,
        value
      });
    },
    disabled: disabled
  }));
};
const getDefaultValue = (selected, options) => {
  if (selected) {
    return options.find(_ref3 => {
      let {
        value
      } = _ref3;
      return selected.value === value;
    });
  } else {
    return options.find(option => option.default);
  }
};
DropdownField.propTypes = {
  options: _propTypes.default.array,
  components: _propTypes.default.array,
  onChange: _propTypes.default.func,
  caption: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.object
};
var _default = exports.default = DropdownField;